import type { I18nFn } from '#/i18n/types/I18nFn';

export const SearchCommonRefinement = {
  ACTION_DATE: 'actionDate',
  AREAS_OF_FOCUS: 'areasOfFocus',
  LOCATION_TYPE: 'locationType',
  LOCALE: 'locale',
  ORG_TYPE: 'orgType',
  RADIUS: 'radius',
  SOURCE: 'source',
  RECENCY: 'recency',
} as const;

export const SEARCH_COMMON_REFINEMENT_NAMES = Object.values(
  SearchCommonRefinement,
);

export function SEARCH_COMMON_REFINEMENT_LABELS(i18n: I18nFn) {
  return {
    [SearchCommonRefinement.AREAS_OF_FOCUS]: i18n('Cause Areas'),
    [SearchCommonRefinement.ACTION_DATE]: i18n('Date'),
    [SearchCommonRefinement.LOCALE]: i18n('Listing Language'),
    [SearchCommonRefinement.LOCATION_TYPE]: i18n('Location Type'),
    [SearchCommonRefinement.ORG_TYPE]: i18n('Org Type'),
    [SearchCommonRefinement.RADIUS]: i18n('Radius'),
    [SearchCommonRefinement.RECENCY]: i18n('Recency'),
  } as Record<SearchCommonRefinementType, string>;
}

export type SearchCommonRefinementType =
  (typeof SearchCommonRefinement)[keyof typeof SearchCommonRefinement];
